import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=553f2be0&scoped=true&"
import script from "./HomeDetail.vue?vue&type=script&lang=js&"
export * from "./HomeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f2be0",
  null
  
)

export default component.exports